import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUserReportedChats, getUserReportedIssues, updateUserReportedIssueStatus, deleteUserReportedIssues, getTableColumnNames, getClientUsers } from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Chat Report Table Column Names
export const fetchReportedTableColumnNames = createAsyncThunk(
  "reportedLegalIssues/fetchReportedTableColumnNames",
  async (chatReport, thunkAPI) => {
    try {
      const response = await getTableColumnNames(chatReport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Fetch Chat Report Table Column Names
export const fetchUserReportedIssues = createAsyncThunk(
  "reportedLegalIssues/fetchUserReportedIssues",
  async (chatReport, thunkAPI) => {
    try {
      const response = await getUserReportedIssues(chatReport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Fetch Chat Report
export const fetchUserReportedChats = createAsyncThunk(
  "reportedLegalIssues/fetchUserReportedChats",
  async (chatReport, thunkAPI) => {
    try {
      const response = await getUserReportedChats(chatReport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Error fetching chat report");
    }
  }
);

// Get Client Users
export const fetchReportedIssuesClientUsers = createAsyncThunk(
  "reportedLegalIssues/fetchReportedIssuesClientUsers",
  async (chatReport, thunkAPI) => {
    try {
      const response = await getClientUsers(chatReport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Error fetching client users");
    }
  }
);

// updateChatFeedbackStatus
export const updateReportedIssueStatus = createAsyncThunk(
  "reportedLegalIssues/updateReportedIssueStatus",
  async (reportedIssueData, thunkAPI) => {
    try {
      const response = await updateUserReportedIssueStatus(reportedIssueData);  
      toast.success(t("Reported issue status updated successfully"));
      return response.data;
    } catch (error) {
      toast.error(t("Failed to update reported issue status"));
      return thunkAPI.rejectWithValue(error || "Error updating reported issue status");
    }
  }
);

// deleteReportedIssues
export const deleteReportedIssues = createAsyncThunk(
  "reportedLegalIssues/deleteReportedIssues",
  async (reportedIssueIds, thunkAPI) => {
    try {
      const response = await deleteUserReportedIssues(reportedIssueIds);  
      toast.success(t("Reported issues deleted successfully"));
      return response.data;
    } catch (error) {
      toast.error(t("Failed to delete reported issues"));
      return thunkAPI.rejectWithValue(error || "Error deleting reported issues");
    }
  }
);